import { z } from 'zod';

export const purchaseOrderCommentSchema = z.object({
  id: z.int(),
  value: z
    .string()
    .trim()
    .min(1, 'this value should not be null')
    .max(3000, 'this value have to much characters'),
});

export type PurchaseOrderCommentInput = z.input<
  typeof purchaseOrderCommentSchema
>;

export type PurchaseOrderCommentValues = z.infer<
  typeof purchaseOrderCommentSchema
>;
